export default "__VITE_ASSET__CiecEHvq__"